import React from "react";
import { useIntl } from "react-intl";
import { Box } from "@mui/material";

import { TextInput } from "../../../common/form-controls";
// import { MenuItem } from "../../../common/menu";
import { Button } from "../../../common/buttons";
// import { REQUEST_PRIORITIES, REQUEST_SOURCES } from "../../../../utils/brm-utils";

import { CreateRequestForm } from "../../../../types/brm/request-types";
import "./styles.less";

type RequestInputProps = {
    requestUrl: string;
    setRequestUrl: (url: string) => void;
    disabled: boolean;
    error?: boolean;
    errorMessage?: string;
};

// type RequestSelectInputProps = {
//     disabled: boolean;
//     value: string;
//     onChange: (value: string) => void;
//     error?: {
//         value: string;
//         message: string;
//     };
// };

type SubmitCancelButtonProps = {
    disabled: boolean;
    onClick: () => void;
};

type CreateRequestFormProps = {
    form: CreateRequestForm;
    setForm: React.Dispatch<React.SetStateAction<CreateRequestForm>>;
    disabled: boolean;
    validationErrors: {
        outer_link?: {
            additional_info: string;
            code: string;
            field: string;
            message: string;
            type: string;
            value: string;
        };
    };
    onSubmit: () => void;
    onCancel: () => void;
};

const RequestUrlInput: React.FC<RequestInputProps> = ({ requestUrl, setRequestUrl, disabled, error, errorMessage }) => {
    const intl = useIntl();
    return (
        <TextInput
            label={intl.formatMessage({
                id: "create-request-dialog.input-request-url",
            })}
            value={requestUrl}
            onChange={(event) => setRequestUrl(event.target.value)}
            disabled={disabled}
            error={error}
            errorMessage={errorMessage}
        />
    );
};

// const RequestPriorityInput: React.FC<RequestSelectInputProps> = ({ disabled, value, onChange, error }) => {
//     const intl = useIntl();

//     const requestPriorityList = [
//         {
//             key: REQUEST_PRIORITIES.LOW,
//             text: "Низкий",
//         },
//         {
//             key: REQUEST_PRIORITIES.MEDIUM,
//             text: "Средний",
//         },
//         {
//             key: REQUEST_PRIORITIES.HIGH,
//             text: "Высокий",
//         },
//     ];

//     const label = intl.formatMessage({
//         id: "create-request-dialog.input-request-priority",
//     });

//     return (
//         <SelectInput
//             error={error?.value === value}
//             errorMessage={error?.message}
//             label={label}
//             value={value}
//             disabled={disabled}
//             onChange={(event: React.ChangeEvent<{ value: string }>) => onChange(event.target.value)}
//         >
//             {requestPriorityList.map(({ key, text }) => (
//                 <MenuItem key={key} value={key}>
//                     {text}
//                 </MenuItem>
//             ))}
//         </SelectInput>
//     );
// };

// const RequestSourceInput: React.FC<RequestSelectInputProps> = ({ disabled, value, onChange, error }) => {
//     const intl = useIntl();

//     const requestSourceList = [
//         {
//             key: REQUEST_SOURCES.JIRA_TASK,
//             text: "Задача Jira",
//         },
//         {
//             key: REQUEST_SOURCES.APPLICATION,
//             text: "Заявка",
//         },
//     ];

//     const label = intl.formatMessage({
//         id: "create-request-dialog.input-request-source",
//     });

//     return (
//         <SelectInput
//             error={error?.value === value}
//             errorMessage={error?.message}
//             label={label}
//             value={value}
//             disabled={disabled}
//             onChange={(event: React.ChangeEvent<{ value: string }>) => onChange(event.target.value)}
//         >
//             {requestSourceList.map(({ key, text }) => (
//                 <MenuItem key={key} value={key}>
//                     {text}
//                 </MenuItem>
//             ))}
//         </SelectInput>
//     );
// };

// const RequestIdInput: React.FC<RequestInputProps> = ({ requestUrl: requestId, setRequestUrl: setRequestId, disabled, error }) => {
//     const intl = useIntl();
//     return (
//         <TextInput
//             label={intl.formatMessage({
//                 id: "create-request-dialog.input-request-id",
//             })}
//             value={requestId}
//             onChange={(event) => setRequestId(event.target.value)}
//             disabled={disabled}
//             error={error?.value === requestId}
//             errorMessage={error?.message}
//         />
//     );
// };

const SubmitButton: React.FC<SubmitCancelButtonProps> = ({ disabled, onClick }) => {
    const intl = useIntl();
    const text = intl.formatMessage({ id: "create-request-dialog.submit.text" });

    return (
        <Button disabled={disabled} variant="contained" className="create-request-dialog-form-submit" onClick={onClick}>
            {text}
        </Button>
    );
};

const CancelButton: React.FC<SubmitCancelButtonProps> = ({ disabled, onClick }) => {
    const intl = useIntl();
    const text = intl.formatMessage({ id: "create-request-dialog.cancel.text" });

    return (
        <Button disabled={disabled} variant="outlined" className="create-request-dialog-form-cancel" onClick={onClick}>
            {text}
        </Button>
    );
};

const CreateRequestForm: React.FC<CreateRequestFormProps> = ({ form, setForm, disabled, onSubmit, onCancel, validationErrors }) => {
    return (
        <Box className="create-request-dialog-form">
            <RequestUrlInput
                error={validationErrors?.outer_link?.value === form.requestUrl}
                errorMessage={validationErrors?.outer_link?.message}
                requestUrl={form.requestUrl}
                setRequestUrl={(value) => setForm({ ...form, requestUrl: value })}
                disabled={disabled}
            />

            {/* <RequestPriorityInput
                error={validationErrors?.find((error) => error.field === "request_priority") || undefined}
                disabled={disabled}
                value={form.requestPriority}
                onChange={(value) => setForm({ ...form, requestPriority: value })}
            /> */}

            {/* <RequestSourceInput
                error={validationErrors?.find((error) => error.field === "request_source") || undefined}
                disabled={disabled}
                value={form.requestSource}
                onChange={(value) => setForm({ ...form, requestSource: value })}
            /> */}

            {/* <RequestIdInput
                error={validationErrors?.find((error) => error.field === "request_id") || undefined}
                requestUrl={form.requestId}
                setRequestUrl={(value) => setForm({ ...form, requestId: value })}
                disabled={disabled}
            /> */}

            <Box className="create-request-dialog-form-buttons">
                <SubmitButton disabled={disabled} onClick={onSubmit} />
                <CancelButton disabled={disabled} onClick={onCancel} />
            </Box>
        </Box>
    );
};

export default CreateRequestForm;
